import { create } from "zustand";

export interface INoteStore {
  activeNoteId: string | null;
  setActiveNoteId: (value: string) => void;
}

const useNoteStore = create<INoteStore>((set) => ({
  activeNoteId: null,
  setActiveNoteId: (activeNoteId) => set({ activeNoteId }),
}));

export default useNoteStore;
